import React from 'react';
import ErrorRecordProgressiveList from './ErrorRecordProgressiveList';
import { ERROR_RECORD_LIST_MASKS } from '../../utils/errorRecordListMasks';

export default function ZoznamInt(props) {
  return <ErrorRecordProgressiveList mask={ERROR_RECORD_LIST_MASKS.int} {...props} />;
}
